import styled from "styled-components";

import { ViewWithSidebarContent } from "@src/modules/DeviceStatus/shared/components";
import { media } from "@src/common/styles/mixins";
import { TOGGLE_SIDEBAR_BUTTON_WIDTH } from "@src/modules/DeviceStatus/Devices/DeviceInfoView/DeviceInfoSidebar/DeviceInfoSidebar.components";
import {
  DEFAULT_MARGIN_L,
  DEFAULT_MARGIN_M,
  DEFAULT_MARGIN_XXL,
} from "@src/common/styles/const";
import { BoxWrapper } from "@src/modules/DeviceStatus/Devices/DeviceInfoView/shared/components";

export const StyledViewWithSidebarContent = styled(ViewWithSidebarContent)`
  display: flex;
  flex-direction: column;
  gap: ${DEFAULT_MARGIN_M}px;
  max-width: 1000px;
  margin-left: 225px;
  padding: ${DEFAULT_MARGIN_XXL}px;

  ${media.only("LAPTOP_LARGE")`
    margin-left: 0;
  `}

  ${media.only("LAPTOP")`
    margin-left: 0;
    padding: ${DEFAULT_MARGIN_L}px
  `}

  ${media.only("TABLET")`
    width: calc(100% - ${TOGGLE_SIDEBAR_BUTTON_WIDTH}px);
    padding: ${DEFAULT_MARGIN_L}px;
    margin-left: ${TOGGLE_SIDEBAR_BUTTON_WIDTH}px;
  `}

  ${media.down("MOBILE")`
    width: 100%;
    margin-left: 0;
    padding: ${DEFAULT_MARGIN_M}px;
  `}
`;

export const StyledBoxWrapper = styled(BoxWrapper)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 0px;
  margin: 0;
`;

export const BaseBoxHeader = styled.div`
  align-self: stretch;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: ${DEFAULT_MARGIN_M}px ${DEFAULT_MARGIN_L}px;
  box-sizing: border-box;
  border-bottom: 1px solid #d5e2ea;
`;

export const StyledBoxHeader = styled(BaseBoxHeader)`
  display: flex;
  flex-direction: row;
`;

export const BaseBoxBody = styled.div`
  align-items: center;
  align-self: stretch;
  padding: ${DEFAULT_MARGIN_M}px ${DEFAULT_MARGIN_L}px;
  gap: 24px;
  margin: auto 0;
`;

export const StyledBoxBody = styled(BaseBoxBody)`
  display: flex;
  flex-direction: row;
`;
